<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <divisoria-descricao
            :titulo="'Dados de envio'"
            :descricao="'Preencha os dados inicias para envio e vincule o gerente responsável'"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col :cols="'6'">
          <div style="display: flex;">
            <div>
              <legend style="font-size: 14px;">
                Pessoa
              </legend>
            </div>
            <b-btn
              v-b-tooltip.hover.top
              title="Abrir cadastro em nova aba"
              size="sm"
              variant="none"
              class="btn-actions"
              style="width: 35px;margin-left: -0.5rem;margin-top: -0.4rem;"
              @click="abrirCadastroPessoa"
            >
              <font-awesome-icon
                :icon="faExternalLinkAlt"
                :class="'text-primary'"
                style="width:22px"
              />
            </b-btn>
          </div>
          <pessoa-select
            ref="pessoaMultiselect"
            v-model="proposta.pessoa"
            :require="true"
            :multiple="false"
            :label="''"
            :disabled="desabilitarSelecaoPessoa"
            @input="pessoaSelecionada"
          />
        </b-col>
        <b-col cols="6">
          <telefone-celular
            :value="telefoneContato"
            :disabled="true"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-form-group
          label="E-mail"
          class="col-6"
        >
          <b-form-input
            v-model="emailPessoa"
            :disabled="true"
          />
        </b-form-group>
        <b-col cols="6">
          <div class="div-email">
            <div>
              <legend style="font-size: 14px">
                E-mails CC</legend>
            </div>
            <div style="padding-left: 0.4rem">
              <i
                v-b-tooltip.hover.html
                title="E-mails que receberão a cópia do e-mail de notificação referente ao envio da proposta comercial com link de acesso ao Portal.
                <strong><br>Atenção: qualquer registro realizado pelo e-mail CC no portal externo ficará registrado com os dados da pessoa principal vinculada a proposta.</strong>"
                style="font-size: 0.65rem"
                class="question-icon"
              >
                <font-awesome-icon :icon="faQuestionCircle" />
              </i>
            </div>
          </div>
          <b-form-tags
            v-model="proposta.emailsCC"
            input-id="tags-emails"
            placeholder=""
            separator=" "
            invalid-tag-text=""
            duplicate-tag-text=""
            :tag-validator="validator"
            :add-button-text="'Adicionar'"
            remove-on-delete
            tag-class="tags"
            :disabled="proposta.id && (proposta.statusProposta !== 'pendenteenvio' && proposta.statusProposta !== 'naoaprovada')"
            @tag-state="onTagState"
          />
          <small
            v-if="invalidTags.length > 0"
            class="text-danger"
          >Insira um email válido</small>
          <small
            v-else-if="duplicateTags.length > 0"
            class="text-danger"
          >E-mail já inserido nesse campo
          </small>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <responsavel-select
            ref="filtroGerente"
            v-model="proposta.gerente"
            :label="'Responsável (Auditar)'"
            :require-usuario="true"
            :disabled="proposta.id && (proposta.statusProposta !== 'pendenteenvio' && proposta.statusProposta !== 'naoaprovada')"
            @input="gerenteSelecionado"
          />
        </b-col>
        <b-form-group
          label="E-mail do responsável"
          class="col-6"
        >
          <b-form-input
            v-model="emailGerente"
            :disabled="true"
          />
        </b-form-group>
      </b-row>

      <b-row
        v-if="proposta.tipoProposta && proposta.tipoProposta !== 'semchecklist'"
        class="mt-1"
        align-v="center"
      >
        <b-col cols="12">
          <legend style="font-size: 14px">
            Contratante(s)</legend>
          <b-form-tags
            id="tags-empresa"
            v-model="proposta.empresasPessoa"
            :placeholder="proposta.empresasPessoa && proposta.empresasPessoa.length > 0 ? '' : 'O sistema vinculará automaticamente o contratante ao realizar o cadastro de empresa!'"
            :disabled="true"
            separator=" "
          >
            <template v-slot="{ tags }">
              <b-badge
                v-for="tag in tags"
                :key="tag"
                v-b-tooltip.hover.top
                title="Abrir cadastro em nova aba"
                variant="success"
                class="mr-50"
                style="cursor: pointer;"
                @click="abrirCadastroEmpresa(JSON.parse(tag).id)"
              >
                <span style="font-size: 11px;font-weight: 500;">{{ JSON.parse(tag).cadastroFederal + ' - ' + JSON.parse(tag).razaoSocial }}</span>
              </b-badge>
            </template>
          </b-form-tags>
        </b-col>
      </b-row>

      <empresa-contrante
        ref="empresaContratante"
        :value="proposta.empresasPessoa"
        :tipo-proposta="proposta.tipoProposta"
        :pessoa="proposta.pessoa"
        :mostrar-botao="proposta.id && (proposta.statusProposta !== 'pendenteenvio' && proposta.statusProposta !== 'naoaprovada') && (!proposta.empresasPessoa || proposta.empresasPessoa.length === 0)"
        :status-proposta="proposta.statusProposta"
        :proposta-id="proposta.id"
        :proposta="proposta"
        @select="selecionadoEmpresas($event, false)"
        @salvo-contratante="selecionadoEmpresas($event, true)"
        @remover-empresa="proposta.empresasPessoa = []"
      />

      <!--Checklist-->
      <b-row
        v-if="proposta.tipoProposta === 'constituicao' || proposta.tipoProposta === 'transferencia'"
        class="mt-2"
      >
        <b-col>
          <checklist
            ref="checklist"
            v-model="proposta"
            :gerado-proposta="proposta.geradoProposta"
            @habilitar-botao="habilitarBotao"
          />
        </b-col>
      </b-row>

      <!--Serviços e Pacote-->
      <div v-if="mostraGrupoItens">
        <b-row class="mt-2">
          <b-col>
            <divisoria-descricao
              :titulo="'Itens da proposta'"
              :descricao="'Preencha os dados personalizados e selecione os serviços dessa proposta'"
            />
          </b-col>
        </b-row>

        <div
          :class="[
            {
              'desabilitar-inputs': proposta.id
                && (proposta.statusProposta !== 'pendenteenvio'
                  && proposta.statusProposta !== 'naoaprovada'
                  && (!proposta.etiquetas.some(som => som.descricao === 'Em Alteração')
                    || permissaoAlterarPropostaAprovada === false))
            }
          ]"
        >
          <b-row>
            <b-form-group
              label="Template da proposta"
              class="col-9"
            >
              <validation-provider
                #default="{ errors }"
                name="Template da proposta"
                :rules="'required'"
              >
                <b-form-select
                  v-model="proposta.templateProposta"
                  :options="[{ value: 1, text: 'Proposta padrão'}, { value: 2, text: 'Proposta 2'}, { value: 3, text: 'Proposta 3'}, { value: 4, text: 'Proposta 4'}, { value: 5, text: 'Proposta 5'}]"
                  :disabled="true"
                />
                <small
                  v-if="errors[0]"
                  class="text-danger"
                >O campo Template da proposta é obrigatório</small>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="Gera contrato"
              class="col-3"
            >
              <b-form-select
                v-model="proposta.geraContrato"
                :options="[
                  { value: true, text: 'Sim' },
                  { value: false, text: 'Não' },
                ]"
                :disabled="desabilitarGeraContrato"
                @input="alteraTemplateContrato"
              />
            </b-form-group>
          </b-row>

          <b-row class="mt-1">
            <b-col>
              <div style="display: flex; justify-content: flex-end">
                <div class="mr-50">
                  <legend class="col-form-label pt-0">
                    Tipo do acréscimo/desconto:
                  </legend>
                </div>
                <div>
                  <b-form-radio-group
                    v-model="tipoAcresDesc"
                    :options="[{text: 'R$', value: 'R$'}, {text: '%', value: '%', disabled: true}]"
                    @change="mudarPorcentagem"
                  />
                </div>
              </div>
            </b-col>
          </b-row>

          <tabela-pacote-servico
            v-model="proposta"
            :tipo-acres-desc="tipoAcresDesc"
            :tabela-index="0"
            @subtotal-pacote="somaValorTotalProposta"
            @subtotal-remove="retiraValorTotalProposta"
            @update-os-constituicao="updateOsConstituicao($event)"
          />

          <tabela-pacote-servico
            v-if="mostrarOutrosPacotes"
            v-model="proposta"
            :tipo-acres-desc="tipoAcresDesc"
            :tabela-index="1"
            @subtotal-pacote="somaValorTotalProposta"
            @subtotal-remove="retiraValorTotalProposta"
          />

          <tabela-pacote-servico
            v-if="mostrarOutrosPacotes"
            v-model="proposta"
            :tipo-acres-desc="tipoAcresDesc"
            :tabela-index="2"
            @subtotal-pacote="somaValorTotalProposta"
            @subtotal-remove="retiraValorTotalProposta"
          />

          <tabela-servico-proposta
            v-if="mostrarTabelaServicos"
            v-model="proposta.servicos"
            :proposta="proposta"
            :tipo-acres-desc="tipoAcresDesc"
            @subtotal-servicos="somaValorTotalProposta"
            @update-os-constituicao="updateOsConstituicao($event)"
          />

          <tabela-servico-adicional
            ref="tabelaServicoAdicional"
            v-model="proposta.servicosAdicionais"
            :proposta="proposta"
            :tipo-acres-desc="tipoAcresDesc"
            @subtotal-servicos-adicionais="somaValorTotalProposta"
            @update-os-constituicao="updateOsConstituicao($event)"
          />
        </div>

        <b-row>
          <b-col
            style="
            display: flex;
            justify-content: flex-end;
            word-break: break-all;
          "
          >
            <b-table
              :items="[proposta.valorTotalPropostaRCC]"
              :fields="[
                {
                  key: 'valorTotal',
                  label: 'Valor total',
                  thStyle: 'font-size: 14.5px;',
                },
              ]"
              bordered
              class="tabela-total"
            >
              <template #head(valorTotal)>
                <div>
                  <i
                    v-if="proposta.propostasPacotes.length > 1"
                    v-b-tooltip.hover.html
                    title="Quando a proposta tem escolha de pacote e ação de escolha estiver pendente com a pessoa, o sistema considerará no valor total da proposta somente o pacote nível I."
                    style="font-size: 0.65rem; display: inline-flex;padding: 3px;"
                    class="question-icon"
                  >
                    <font-awesome-icon :icon="faQuestionCircle" />
                  </i>
                  <span>Valor total: {{ proposta.valorTotalPropostaAuditar ? proposta.valorTotalPropostaAuditar.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : 0.0 | converteValor }}</span>
                </div>
              </template>
              <template #cell(valorTotal)="{ item }">
                <span style="font-size: 12.8px">RCC: {{ item ? item.toLocaleString("pt-BR", { style: "currency", currency: "BRL", }) : 0.0 | converteValor }}</span>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.desabilitar-inputs {
  pointer-events: none;
}

.alinhar-campo-pessoa {
  display: flex;
  align-items: baseline;
}

#tags-empresa ::placeholder {
  font-style: italic;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { ValidationProvider } from 'vee-validate'
import {
  faQuestionCircle, faExternalLinkAlt,
} from '@fortawesome/free-solid-svg-icons'
import { getUserData, isAdmin, permitidoAcessarRecurso } from '@/auth/utils'
import { abrirEmNovaGuia } from '@/@core/utils/utils'

export default {
  name: 'DadosEnvio',
  components: {
    FontAwesomeIcon,
    ValidationProvider,
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    PessoaSelect: () => import('@/shared/components/pessoa-select/PessoaSelect.vue'),
    TelefoneCelular: () => import('@/shared/components/telefone-celular/TelefoneCelular.vue'),
    ResponsavelSelect: () => import('@/shared/components/usuario-interno-select/UsuarioInternoSelect.vue'),
    TabelaServicoProposta: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/tabela-servico/TabelaServicoProposta.vue'),
    TabelaServicoAdicional: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/tabela-servico-adicional/TabelaServicoAdicional.vue'),
    TabelaPacoteServico: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/tabela-pacote-servico/TabelaPacoteServico.vue'),
    Checklist: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/checklist-proposta/ChecklistProposta.vue'),
    EmpresaContrante: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/empresa-contratante/EmpresaContratante.vue'),
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    tipoProposta: {
      type: String,
      default: 'semchecklist',
    },
  },
  data() {
    return {
      faQuestionCircle,
      faExternalLinkAlt,
      proposta: this.value,
      invalidTags: [],
      duplicateTags: [],
      desabilitarTemplate: true,
      telefoneContato: {},
      emailPessoa: null,
      emailGerente: null,
      tipoAcresDesc: '',
      totalAuditarServico: 0,
      totalRCCServico: 0,
      totalAuditarServicoAdicional: 0,
      totalRCCServicoAdicional: 0,
      totalAuditarPacote: 0,
      totalRCCPacote: 0,
      desabilitarGeraContrato: false,
      permissaoAlterarPropostaAprovada: getUserData().permissaoAlterarPropostaAprovada,
    }
  },
  computed: {
    ...mapGetters('proposta', ['getCheckOsConstituicao', 'getStatusProposta']),
    mostraGrupoItens() {
      return this.proposta.tipoProposta === 'semchecklist'
      || ((this.proposta.tipoProposta === 'constituicao' || this.proposta.tipoProposta === 'transferencia') && this.proposta.geradoProposta)
    },
    mostrarOutrosPacotes() {
      return (this.proposta.tipoProposta === 'constituicao' || this.proposta.tipoProposta === 'transferencia') && !this.proposta.filial && this.proposta?.propostasPacotes?.length > 1
    },
    desabilitarSelecaoPessoa() {
      return (this.proposta.id && (this.proposta.statusProposta !== 'pendenteenvio' && this.proposta.statusProposta !== 'naoaprovada'))
        || ((this.proposta.statusProposta === 'pendenteenvio' || this.proposta.statusProposta === 'naoAprovada') && this.proposta.copia && this.proposta.tipoProposta !== 'semchecklist')
    },
    mostrarTabelaServicos() {
      return (this.proposta.tipoProposta === 'semchecklist') || (this.proposta.tipoProposta !== 'semchecklist' && this.proposta.servicos.some(som => som.servico))
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.proposta = value
        this.desabilitarGeraContrato = this.tipoProposta === 'semchecklist'
        this.adicionarDados(this.proposta)
      }
    },
  },
  created() {
    this.proposta = this.value
    this.desabilitarGeraContrato = this.tipoProposta === 'semchecklist'
    if (this.proposta) {
      this.adicionarDados(this.proposta)
    } else {
      this.tipoAcresDesc = 'R$'
    }
  },
  methods: {
    ...mapActions('proposta', ['setCheckOsConstituicao']),
    selecionadoEmpresas(value, salvo) {
      if (!salvo && (!this.proposta.id || this.proposta.statusProposta === 'pendenteenvio' || this.proposta.statusProposta === 'naoaprovada')) {
        this.proposta.empresasPessoa = []
        this.proposta.empresasPessoa.push(value)
      } else if (salvo) {
        this.proposta.empresasPessoa.push(value)
      }
    },
    abrirCadastroPessoa() {
      if (isAdmin()) {
        if (this.proposta.pessoa && this.proposta.pessoa.id > 0) {
          abrirEmNovaGuia('editar-pessoa', this.proposta.pessoa.id)
        } else {
          abrirEmNovaGuia('pessoas')
        }
      } else {
        const ability = permitidoAcessarRecurso('pessoa')
        if (ability) {
          if (this.proposta.pessoa && this.proposta.pessoa.id > 0 && ability.actions.some(som => som === 'update')) {
            abrirEmNovaGuia('editar-pessoa', this.proposta.pessoa.id)
          } else {
            abrirEmNovaGuia('pessoas')
          }
        } else {
          this.$erro('Você não tem permissão para acessar esse cadastro. Contate o administrador!')
        }
      }
    },
    abrirCadastroEmpresa(value) {
      if (isAdmin()) {
        abrirEmNovaGuia('editar-emp', value)
      } else {
        const ability = permitidoAcessarRecurso('empresa')
        if (ability) {
          if (ability.actions.some(som => som === 'update')) {
            abrirEmNovaGuia('editar-emp', value)
          } else {
            abrirEmNovaGuia('empresas')
          }
        } else {
          this.$erro('Você não tem permissão para acessar esse cadastro. Contate o administrador!')
        }
      }
    },
    adicionarDados(dados) {
      this.telefoneContato = dados.pessoa ? dados.pessoa.telefoneContato : {}
      this.emailPessoa = dados.pessoa ? dados.pessoa.email : null
      this.emailGerente = dados.gerente ? dados.gerente.email : null
      this.tipoAcresDesc = dados.porcentagem ? '%' : 'R$'
    },
    pessoaSelecionada(value) {
      if (value) {
        this.telefoneContato = {
          telefone: value.telefone,
          telefoneWhatsApp: value.telefoneWhatsApp,
          celular: value.celular,
          celularWhatsApp: value.celularWhatsApp,
        }
        this.emailPessoa = value.email
      }
      this.proposta.empresasPessoa = []
    },
    validator(tag) {
      const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(tag)
    },
    onTagState(valid, invalid, duplicate) {
      this.invalidTags = invalid
      this.duplicateTags = duplicate
    },
    gerenteSelecionado(value) {
      if (value) {
        this.emailGerente = value.email
      }
    },
    alteraTemplateContrato(value) {
      if (!value) {
        this.proposta.templateContrato = null
      } else {
        this.proposta.templateContrato = 'Contrato padrão'
      }
    },
    somaValorTotalProposta(array) {
      if (array.tipo === 'servico') {
        this.totalAuditarServico = array.subTotal
        this.totalRCCServico = array.subTotalRCC
      }

      if (array.tipo === 'servicoAdicional') {
        this.totalAuditarServicoAdicional = array.subTotal
        this.totalRCCServicoAdicional = array.subTotalRCC
      }

      if (array.tipo === 'pacote') {
        this.totalAuditarPacote = array.subTotal
        this.totalRCCPacote = array.subTotalRCC
      }

      this.proposta.valorTotalPropostaAuditar = this.totalAuditarServico + this.totalAuditarServicoAdicional + this.totalAuditarPacote
      this.proposta.valorTotalPropostaRCC = this.totalRCCServico + this.totalRCCServicoAdicional + this.totalRCCPacote
    },
    retiraValorTotalProposta(array) {
      this.totalAuditarPacote = array.subTotal
      this.totalRCCPacote = array.subTotalRCC

      this.proposta.valorTotalPropostaAuditar -= this.totalAuditarPacote
      this.proposta.valorTotalPropostaRCC -= this.totalRCCPacote
    },
    limparDadosEnvio() {
      this.telefoneContato = {}
      this.emailPessoa = null
      this.emailGerente = null
    },
    mudarPorcentagem(value) {
      if (value === '%') {
        this.proposta.porcentagem = true
      } else {
        this.proposta.porcentagem = false
      }
    },
    habilitarBotao(value) {
      this.$emit('habilitar-botao', value)
    },
    setEmpresaContratanteObrigatorio() {
      this.$refs.empresaContratante.obrigatorio = true
    },
    updateOsConstituicao(pacoteSelecionado) {
      if (this.proposta.statusProposta !== 'finalizada') {
        let pacoteServico = false
        if (pacoteSelecionado && pacoteSelecionado.servicos.length > 0) {
          pacoteServico = pacoteSelecionado.servicos.some(s => s.osConstituicao)
        } else {
          pacoteServico = this.proposta.propostasPacotes[0].servicos?.some(a => a.osConstituicao)
        }
        const servico = this.proposta.servicos?.some(s => s.servico?.osConstituicao)
        const servicoAdicional = this.proposta.servicosAdicionais?.some(s => s.servico?.osConstituicao)
        if (pacoteServico || servico || servicoAdicional) {
          this.setCheckOsConstituicao(true)
          this.proposta.empresasPessoa = []
          if (this.proposta.semContratante) {
            this.proposta.semContratante = false
          }
        } else {
          this.setCheckOsConstituicao(false)
        }
      }
    },
  },
}
</script>
